import { router } from '~/router';
import Table from 'Components/SimpleTable';
import { sortBy } from 'lodash';
import React from 'react';
import statusToColor from 'utils/statusToColor';

const columns = [
    { label: 'Organization', dataKey: 'organization_name' },
    { label: 'Site', dataKey: 'site_name' },
    { label: 'Root Device', dataKey: 'root_device_name', transform: row => `${row.root_device_name} (${row.root_device_equipment_name})` },
    { label: 'Name', dataKey: 'name' },
    { label: 'Status', dataKey: 'status', transform: ({ status }) => <span style={{ color: statusToColor(status) }}>{status}</span> }
];

const Devices = props => {
    const { devices = [] } = props;

    const
        onRowClick = id => router.navigate(`/devices/${id}/details`),
        rows = sortBy(devices, ['organization_name', 'site_name', 'root_device_name', 'name']);

    return (
        <Table columns={columns} onRowClick={onRowClick} rows={rows} rowsPerPage={500}/>
    );
};

export default Devices;
